export const fmtMXN = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const v = typeof n === "number" ? n : parseFloat(String(n).replace(/,/g, ""));
  if (isNaN(v)) return "—";
  return new Intl.NumberFormat("es-MX", {
    style: "currency", currency: "MXN", minimumFractionDigits: 2,
  }).format(v);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    if (isNaN(d.getTime())) return String(iso);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return String(iso);
  }
};

export const estadoLabel = {
  prospecto: "Prospecto",
  oferta: "Oferta",
  promesa: "Promesa",
  cierre: "Cierre",
};

export const tipoDocLabel = {
  comision_mercantil_venta: "Comisión Mercantil (Venta)",
  carta_oferta_compraventa: "Carta Oferta de Compraventa",
  promesa_compraventa: "Promesa de Compraventa",
  arrendamiento_habitacional: "Arrendamiento Habitacional",
};
